import { reduce } from 'ramda'

/**
 * Service factory.
 */
export default class HttpCacheServiceFactory {
  /**
   * Constructor
   *
   * @param {Array<HttpCacheAbstractAdapter>} services
   */
  constructor(services) {
    this.services = services
  }

  /**
   * Creates a service for a given pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {HttpCacheAbstractService}
   */
  create(poolConfig) {
    const service = reduce(
      (carry, service) => (service.supports(poolConfig) ? service : carry),
      null,
      this.services,
    )

    if (service === null) {
      throw new Error(`Service not found for pool ${poolConfig.name}`)
    }

    return service
  }
}
